import client from "./axiosConfig";

export const createTask = (data) => {
  const config = {
    url: "/tracker/task/",
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const getTodayTasks = () => {
  const config = {
    url: "/tracker/day/todays_tasks/",
    method: "GET",
  };
  const response = client(config);
  return response;
}
